export const getBlobFromDataUrl = async dataUrl => (await fetch(dataUrl)).blob();

export const getBlobObjectUrl = blob => window.URL.createObjectURL(blob);

const convertBase64UrlToBlobObjectUrl = async dataUrl => getBlobObjectUrl(await getBlobFromDataUrl(dataUrl));

export default convertBase64UrlToBlobObjectUrl;
